import styled from 'styled-components'

import { StyledInputError } from 'components/Input/styles'

export const StyledDropdownError = styled(StyledInputError)`
  margin-top: 0;
`
